import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {OfferSectionName} from "./track_amplitude_offer_view_section";

interface ITrackAmplitudeOfferExpandSectionParams {
    sectionName: OfferSectionName;
    itemId: number;
}

export const trackAmplitudeOfferExpandSection = ({sectionName, itemId}: ITrackAmplitudeOfferExpandSectionParams) => {
    trackAmplitudeEvent("expand_section", {
        section_name: sectionName,
        location: "investment_page",
        item_id: itemId,
        property_id: null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {OfferSectionName} from "./track_amplitude_offer_view_section";

interface ITrackAmplitudeOfferExpandSectionParams {
    sectionName: OfferSectionName;
    itemId: number;
}

export const trackAmplitudeOfferExpandSection = ({sectionName, itemId}: ITrackAmplitudeOfferExpandSectionParams) => {
    trackAmplitudeEvent("expand_section", {
        section_name: sectionName,
        location: "investment_page",
        item_id: itemId,
        property_id: null
    });
};
